import { render, staticRenderFns } from "./ReferralFutureAddressForm.vue?vue&type=template&id=6e0e3d6e&"
import script from "./ReferralFutureAddressForm.vue?vue&type=script&lang=ts&"
export * from "./ReferralFutureAddressForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports